
import { Component, Vue, Watch } from "vue-property-decorator";
import { Loading, CardLavorazione, WorkflowLavorazione, ProgressoLavorazione, ProgressoSpedizione, LavorazioniCards, LoadingTemplateType, CardEntityMetadata } from "@/components";
import { Lavorazione, StatoLavorazione, VariazioneLavorazione, RigaDistinta, RequestSalvaDatiAggiuntiviLavorazione } from "@/models";
import { store, StoreActions, StoreMutations } from '@/store';
import dayjs from "dayjs";
import saveAs from "file-saver";

@Component({
    components: {
        Loading,
        CardLavorazione,
        WorkflowLavorazione,
        ProgressoLavorazione,
        ProgressoSpedizione,
        LavorazioniCards,
        CardEntityMetadata,
    }
})
export default class LavorazioneDettaglio extends Vue {

    public idLavorazione!: string;
    public mostraHeader = true;
    public dialog = false;
    public inModificaNote = false;
    public valoreNoteTemp = '';

    modificaNote() {
        if (this.lavorazione) {
            this.valoreNoteTemp = this.lavorazione.note;
            this.inModificaNote = true;
        }
    }

    async inviaModificaNote() {
        if (this.lavorazione) {
            let ok = await store.dispatch(StoreActions.InviaModificaNoteLavorazione, { idLavorazione: this.lavorazione.id, note: this.valoreNoteTemp });

            if (ok) {
                this.inModificaNote = false;
            }
            else {
                store.commit(StoreMutations.SetMessaggiErrore, ["Errore durante il tentativo di modifica delle note della lavorazione."]);
            }
        }
    }
    get lavorazione(): Lavorazione | undefined {
        return store.state.lavorazioneCorrente;
    }

    get azioniDisponibili(): boolean {
        return store.state.uiLavorazione && store.state.uiLavorazione.azioni.length > 0;
    }

    get distintaDinamicaCaricata(): boolean {
        return (store.state.lavorazioneCorrente != undefined && store.state.lavorazioneCorrente.distintaDinamica != undefined)
    }

    get distintaStaticaCaricata(): boolean {
        return (store.state.lavorazioneCorrente != undefined && store.state.lavorazioneCorrente.distintaStatica != undefined)
    }

    get loadTemplateCorrente(): LoadingTemplateType {
        return LoadingTemplateType.LavorazioneDettaglio;
    }

    public headers = [
        { text: "Indice", sortable: false },
        { text: "Codice", sortable: false },
        { text: "Descrizione", sortable: false },
        { text: "Colore", sortable: false },
        { text: "Um", sortable: false },
        { text: "Quantità", sortable: false },
        { text: "Partita", sortable: false },
        { text: "Utilizzo", sortable: false },
        { text: "Contenitore", sortable: false },
    ];

    @Watch("$route.params.id", { immediate: true })
    onIdChanged(newId: string, oldId: string) {
        if (oldId) {
            store.dispatch(StoreActions.UnwatchLavorazione, oldId);
        }
        this.idLavorazione = newId;
        store.commit(StoreMutations.SetSottotitoloPagina, newId);
        store.dispatch(StoreActions.GetLavorazione, newId);
        store.dispatch(StoreActions.WatchLavorazione, newId);
        store.dispatch(StoreActions.OperazioniEtichetteDremeDisponibiliPerLavorazione, newId);
        store.dispatch(StoreActions.GetResetEPCDisponibile);
        store.dispatch(StoreActions.GetStampaEtichetteRfidDisponibile);
        store.dispatch(StoreActions.GetStampaEtichetteNoRfidDisponibile);
    }

    get loading() {
        return store.state.loading && !this.dialog && !this.caricamentoDistinta;
    }

    get csvButtonLoading() {
        return store.state.uiLavorazione.csvButtonLoading;
    }

    get xlsxPackingListLavorazioneLoading() {
        return store.state.uiLavorazione.xlsxPackingListLavorazioneLoading;
    }


    qtaCalcolataDaDibaStatica(riga: RigaDistinta) {
        let qtaRiga: number = 0;
        if (this.lavorazione && riga.quantitaPerTaglia) {
            let rigaInner: any = this.lavorazione.innerLavorazione;
            riga.quantitaPerTaglia.forEach(qtaTaglia => {
                let field = `capi${qtaTaglia.indice.toString().padStart(2, '0')}_AsInteger`;
                let qta: number = rigaInner[field];

                if (qta) {
                    qtaRiga += qta * qtaTaglia.qta;
                }
            });
        }
        return qtaRiga;
    }

    classeRigaDistinta(riga: RigaDistinta, distPartenzaDinamica: boolean) {
        if (this.lavorazione && this.lavorazione.distintaDinamica && this.lavorazione.distintaStatica) {
            let rigaComparazione: RigaDistinta | undefined;
            if (distPartenzaDinamica) {
                rigaComparazione = this.lavorazione.distintaStatica.righeDistintaDPC.find(x => x.innerRigaDistinta.componente == riga.innerRigaDistinta.componente);
            }
            else {
                rigaComparazione = this.lavorazione.distintaDinamica.righeDistintaDPC.find(x => x.innerRigaDistinta.componente == riga.innerRigaDistinta.componente);
            }

            if (rigaComparazione) {
                let qtaDin = distPartenzaDinamica ? +riga.innerRigaDistinta.quantita.replace(',', '.') : this.qtaCalcolataDaDibaStatica(riga);
                let qtaSta = distPartenzaDinamica ? this.qtaCalcolataDaDibaStatica(rigaComparazione) : +rigaComparazione.innerRigaDistinta.quantita.replace(',', '.');
                if (qtaDin !== qtaSta) {
                    return 'riga-diversa-in-altra-distinta';
                }
            }
            else {
                return 'riga-assente-in-altra-distinta';
            }
        }
        return '';
    }

    public beforeDestroy() {
        if (this.idLavorazione) {
            store.dispatch(StoreActions.UnwatchLavorazione, this.idLavorazione);
        }
    }

    public caricamentoDistinta: boolean = false;

    async caricaDistintaDinamica() {
        if (this.lavorazione) {
            this.caricamentoDistinta = true;
            await store.dispatch(StoreActions.GetDistintaDinamicaPerLavorazione, this.lavorazione.idDistinta);
            this.caricamentoDistinta = false;
        }
    }

    public async downloadCSVDistinta() {
        if (this.distintaDinamicaCaricata) {
            let data = await store.dispatch(StoreActions.DownloadCSVDistintaDinamica, this.lavorazione?.distintaDinamica?.id);
            if (data) {
                saveAs(data, `distinta_dinamica_${this.lavorazione?.distintaDinamica?.id}.csv`);
            }
        }
    }

    public async downloadXLSXPackingListLavorazione() {
        let data = await store.dispatch(StoreActions.DownloadXLSXPackingListLavorazione, this.lavorazione?.id);
            if (data) {
                saveAs(data, `packing_list_lavorazione_${this.lavorazione?.id}.xlsx`);
            }
    }

    public async saveDatiAggiuntivi() {
        const request: RequestSalvaDatiAggiuntiviLavorazione = {
            idLavorazione: this.lavorazione?.id,
            datiAggiuntivi: this.lavorazione?.datiAggiuntivi
        }
        await store.dispatch(StoreActions.SalvaDatiAggiuntiviLavorazione, request);
    }

    async caricaDistintaStatica() {
        if (this.lavorazione) {
            this.caricamentoDistinta = true;
            const smc = {
                stagione: this.lavorazione.stagioneDecodificata.id,
                modello: this.lavorazione.modelloDecodificato.codiceParte,
                colore: this.lavorazione.coloreDecodificato.codiceColore
            };
            await store.dispatch(StoreActions.GetDistintaStaticaPerLavorazione, smc);
            this.caricamentoDistinta = false;
        }
    }

    public vaiAComunicazioneConsumi() {
        if (this.lavorazione && this.lavorazione.distintaStatica) {
            this.$router.push({ name: 'distinta', params: { id: this.lavorazione.distintaStatica.id } });
        }
    }
}
